import PropTypes from 'prop-types';
import React from 'react';

import { InfoItem } from 'src/components/elements';
import BasePopup from 'src/popups/BasePopup';

import styles from './AppointmentDetailsPopup.module.scss';

const AppointmentDetailsPopup = ({ appointmentDetails, onClose }) => {
  if (!appointmentDetails) {
    return null;
  }

  return (
    <BasePopup id="appointment-details" open onClose={onClose} title="Athena Appointment Details">
      <div className={styles.grid}>
        <InfoItem
          title="Appointment ID"
          content={appointmentDetails.appointmentid || 'N/A'}
          textId="appointment-id"
          small
        />
        <InfoItem
          title="Patient ID"
          content={appointmentDetails.patientid || 'N/A'}
          textId="patient-id"
          small
        />
      </div>
      <div className={[styles.grid, 'primary-border-t'].join(' ')}>
        <InfoItem
          title="Date"
          content={appointmentDetails.date || 'N/A'}
          textId="appointment-date"
          small
        />
        <InfoItem
          title="Start Time"
          content={appointmentDetails.starttime || 'N/A'}
          textId="start-time"
          small
        />
      </div>
      <div className={[styles.grid, 'primary-border-t'].join(' ')}>
        <InfoItem
          title="Type"
          content={appointmentDetails.appointmenttype || 'N/A'}
          textId="appointment-type"
          small
        />
        <InfoItem
          title="Status"
          content={appointmentDetails.appointmentstatus || 'N/A'}
          textId="appointment-status"
          small
        />
      </div>
      <div className={[styles.grid, 'primary-border-t'].join(' ')}>
        <InfoItem
          title="Duration"
          content={appointmentDetails.duration ? `${appointmentDetails.duration} minutes` : 'N/A'}
          textId="duration"
          small
        />
        <InfoItem
          title="Provider ID"
          content={appointmentDetails.providerid || 'N/A'}
          textId="provider-id"
          small
        />
      </div>
      <div className={[styles.grid, 'primary-border-t'].join(' ')}>
        <InfoItem
          title="Department ID"
          content={appointmentDetails.departmentid || 'N/A'}
          textId="department-id"
          small
        />
        <InfoItem
          title="Scheduled By"
          content={appointmentDetails.scheduledby || 'N/A'}
          textId="scheduled-by"
          small
        />
      </div>
      <div className={[styles.grid, 'primary-border-t'].join(' ')}>
        <InfoItem
          title="Last Modified"
          content={appointmentDetails.lastmodified || 'N/A'}
          textId="last-modified"
          small
        />
      </div>
    </BasePopup>
  );
};

AppointmentDetailsPopup.propTypes = {
  appointmentDetails: PropTypes.object,
  onClose: PropTypes.func,
};

export default AppointmentDetailsPopup;
